// Dependencies
require("webstrap/type");
require("webstrap/responsive-utilities");

// Styles
require("./rich-text.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/rich-text/index.js
 ** module id = 68
 ** module chunks = 0 1
 **/